import axios from "axios";
import { mediaUrl } from "./publicAudioTools";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function nativeAudioDownload(asset) {
  const link = document.createElement("a");
  link.href = mediaUrl(asset.url);
  link.download = asset.filename;
  link.rel = "noreferrer";
  document.body.append(link); link.click(); link.remove();
}

export async function requestAudioExport(path, payload, headers, signal, progress) {
  const { data: session } = await axios.post(`${API}${path}`, payload, { headers, signal });
  while (!signal.aborted) {
    const { data } = await axios.get(`${API}/stems/exports/${session.session_id}`, {
      headers: { "X-Public-Tools-Token": session.access_token }, signal,
    });
    progress(data.percent || 0);
    if (data.state === "error") throw new Error(data.message || "No se pudo exportar");
    if (data.state === "ready") return data;
    await new Promise((resolve, reject) => {
      const finish = () => { signal.removeEventListener("abort", cancel); resolve(); };
      const timer = setTimeout(finish, 700);
      const cancel = () => { clearTimeout(timer); signal.removeEventListener("abort", cancel); reject(new Error("Exportacion cancelada")); };
      signal.addEventListener("abort", cancel, { once: true });
    });
  }
  throw new Error("Exportacion cancelada");
}
